import React, { useEffect, cloneElement, Children } from 'react';
import { Link, browserHistory } from 'react-router';
import lodash from 'lodash';
import { connect } from 'react-redux';
import { 
    getBinderTaskDetails,
    clearBinderTasks,
} from './../actions/binderActions';
import { binderInstitutionIdSelector } from 'common/selectors';
import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';
import { PageTitle } from 'components/common/Study/PageComponents';
import { Tabs } from 'components/common/Tabs/Tabs';
import styles from './BinderTaskV2.scss';
import { options } from 'common/util/materialTable/options';
import { theme } from 'common/util/materialTable/theme';
import { getCompletedBinderSignatures, getPendingBinderSignatures } from '../selectors/BinderTask';
import { SDFA_TYPE_TASK, EVENT_TYPE_TASK, DOA_TYPE_TASK } from 'common/util/taskHelper';

export const tasksOptions = {
    ...options,
    search : true
};

export const tasksTheme = {
    ...theme,
    overrides : {
        ...theme.overrides,
        MuiToolbar : {
            gutters : {
                height: '0px !important',
                minHeight: '0px !important',
            }
        },
        MuiFormControl : {
            root : {
                display: 'none',
            }
        },
        MuiTableCell : {
            ...theme.overrides.MuiTableCell,
            root : {
                ...theme.overrides.MuiTableCell.root,
                minHeight: '48px',
                height: '48px !important',
                verticalAlign : 'top',
                paddingTop: '16px !important',
                paddingBottom : '7px !important',
                
            }
        },
        MuiTableRow : {
            ...theme.overrides.MuiTableRow,
            root : {
                ...theme.overrides.MuiTableRow.root,
                '& > td:first-child' : {
                    paddingTop: '9px !important',
                }
            }
        }
    }
};

function getTaskPath(taskType, taskId, binderId, institutionId){
    switch (taskType) {
        case SDFA_TYPE_TASK:
            return `/form/processSummary/sdfa?workflowId=${taskId}&binderId=${binderId}&iid=${institutionId}`;
        case EVENT_TYPE_TASK:
            return `/form/event/${taskId}?taskBox=sent`;
        case DOA_TYPE_TASK:
            return `/form/doa/${taskId}?taskBox=sent`;
        default:
            throw new Error(`Unsupported task type: ${taskType}`);
    }
}
export const viewDetails = (materialEvent, data, institutionId, binderId) => {
    const path = getTaskPath(data.taskType, data.id, binderId, institutionId);
    browserHistory.push(path);
};

export const DetailPanel = ({totalTasks, detailedRecipients}) => totalTasks > 1 && detailedRecipients.map(recipient => <div className={styles.recipientDetail}>{recipient}</div>);

export function viewDetailsColumn (institutionId, binderId){
    const viewPath = (task) => getTaskPath(task.taskType, task.id, binderId, institutionId);

    return(
        {
            title: '',
            field: 'viewDetails',
            hidden: false,
            cellStyle : {
                width: 180,
                maxWidth: 180,
                textAlign: 'right',
                textDecoration: 'none',
            },
            headerStyle: {
                width: 180,
                maxWidth: 180,
            },
            render: (task) => 
                <Link className={styles.linkLabel} to={viewPath(task)}>View Details</Link>
        }
    );
}

export function BinderTaskV2(props) {
    const { isLoading } = props;

    useEffect( () => {
        if(lodash.isFunction(props.setSidebarCollapsed)) {
            props.setSidebarCollapsed(true);
        }
        props.getBinderTaskDetails();
        return () => {
            if(lodash.isFunction(props.setSidebarCollapsed)) {
                props.setSidebarCollapsed(false);
            }
            props.clearBinderTasks();
        };
    }, []);

    if (isLoading) {
        return(
            <LoadingStatus
                itemName='tasks'
                loading={true}
                filterQuery={false}
            />
        );
    }

    const childElement = cloneElement(Children.only(props.children), props);

    return(
        <div className={styles.tasksContainer} data-cy="BinderTaskV2">
            <div className={styles.header}>
                <PageTitle>Tasks</PageTitle>
            </div>
            <Tabs
                className={styles.tabs}
                tabs={buildTabs(props.binderId, props.allPending.length)}
                location={location}
            />
            <div className={styles.tasksBody} data-cy="BinderTaskV2-childElement">
                {childElement}
            </div>
        </div>
    );
}

const buildTabs = (binderId, pendingTasksCount) => {
    const mainPath = `/binder/${binderId}/tasks/`;

    return [{
        label: `Incomplete - ${pendingTasksCount}`,
        path: `${mainPath}incomplete`,
        backgroundHighlight: true,
    }, {
        label: 'Complete',
        path: `${mainPath}completed`,
        backgroundHighlight: true,
    }];
};


export default connect( (state, props) => {
    const binderId = lodash.get(state, 'binder.id');
    const institutionId = binderInstitutionIdSelector(state);
    const sdfaIsLoading = lodash.get(state, 'binder.tasksIsLoading', false);
    const completedEventsIsLoading = lodash.get(state, 'binder.completedEventsIsLoading', false);
    const pendingEventsIsLoading = lodash.get(state, 'binder.pendingEventsIsLoading', false);
    const completedDOAsIsLoading = lodash.get(state, 'binder.completedDOAsIsLoading', false);
    const pendingDOAsIsLoading = lodash.get(state, 'binder.pendingDOAsIsLoading', false);

    const isLoading = lodash.some([sdfaIsLoading, pendingDOAsIsLoading, completedDOAsIsLoading, pendingEventsIsLoading, completedEventsIsLoading]);
    const allPending = getPendingBinderSignatures(state);
    const allCompleted = getCompletedBinderSignatures(state);

    return {
        binderId,
        isLoading,
        allPending,
        allCompleted,
        institutionId,
    };
}, {
    getBinderTaskDetails,
    clearBinderTasks,
})(BinderTaskV2);
